// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["__sentryRewritesTunnelPath__"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"221f114588e68c9ce94098f7e2d2c98983a2a535"};globalThis["__sentryBasePath"] = undefined;globalThis["__rewriteFramesAssetPrefixPath__"] = "";import * as Sentry from '@sentry/nextjs';
import {
  sentryBeforeBreadcrumbScrubber,
  sentryBeforeSendScrubber,
  sentryBeforeSendSpanScrubber,
  sentryBeforeSendTransactionScrubber,
} from './utils/sentry-utils';

Sentry.init({
  dsn: 'https://78e0400a593cab89e659988810278b8a@o1302100.ingest.us.sentry.io/4507559385628672',
  enabled:
    process.env.NODE_ENV === 'production' ||
    process.env.VERCEL_ENV === 'vercel-production',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  beforeSend: sentryBeforeSendScrubber,
  beforeBreadcrumb: sentryBeforeBreadcrumbScrubber,
  beforeSendSpan: sentryBeforeSendSpanScrubber,
  beforeSendTransaction: sentryBeforeSendTransactionScrubber,
});
